'use strict';

var React = require('react');
var array = require('../../helpers/array.js');
var component = require('../Button/component.js');
var component$1 = require('../forms/Switch/component.js');
var useHidableCols_styles = require('./useHidableCols.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const LOCAL_STORAGE_TABLE_KEY = 'ds_table_settings__';
const HidableColsSettingsPopin = ({ id, columns, hiddenCols, tempoHiddenCols, hidableColsPopinOpen, onSettingsClick, onCancelClick, makeOnSwitchChange, onSaveClick, labelSettingsTitle, labelSettingsSave, labelSettingsCancel, }) => {
    const idPopin = `${id}-settings-popin`;
    return (React__default.default.createElement(useHidableCols_styles.SettingsContainer, null,
        React__default.default.createElement(component.Button, { id: `${id}-settings`, onClick: onSettingsClick, variant: "secondary", icon: hiddenCols.length > 0 ? 'settings-filled' : 'settings-outlined', title: "table settings filled", disabled: hidableColsPopinOpen }),
        hidableColsPopinOpen ? (React__default.default.createElement(useHidableCols_styles.SettingsPopinContainer, { id: idPopin },
            React__default.default.createElement(useHidableCols_styles.SettingsDiv, null, labelSettingsTitle),
            columns.map(column => (React__default.default.createElement(useHidableCols_styles.FlexDiv, { key: column.key },
                React__default.default.createElement(component$1.Switch, { id: `${idPopin}-switch-${column.key}`, checked: !tempoHiddenCols.includes(column.key), onChange: makeOnSwitchChange(column.key) }),
                React__default.default.createElement(useHidableCols_styles.LabelStyled, null, column.header
                    ? column.header
                    : column.renderHeader
                        ? column.renderHeader({ asDiv: true })
                        : column.headerCustom
                            ? column.headerCustom({ asDiv: true })
                            : null)))),
            React__default.default.createElement(useHidableCols_styles.RowStyled, { space: "s", justifyContent: "flex-end" },
                React__default.default.createElement(component.Button, { variant: "secondary", id: `${idPopin}-cancel`, onClick: onCancelClick }, labelSettingsCancel),
                React__default.default.createElement(component.Button, { id: `${idPopin}-save`, onClick: onSaveClick, disabled: tempoHiddenCols.length === columns.length }, labelSettingsSave)))) : null));
};
function useHidableCols(id, columns, withHidableCols, hidableColsLocalStorageKey, labelSettingsTitle = 'Cacher une colonne', labelSettingsSave = 'Enregistrer', labelSettingsCancel = 'Annuler') {
    if (!withHidableCols && hidableColsLocalStorageKey) {
        throw new Error(`hidableColsLocalStorageKey props is defined on table with id = ${id} but withHidableCols is false`);
    }
    const hiddenColsFromLocalStorage = React.useMemo(() => {
        if (!hidableColsLocalStorageKey) {
            return undefined;
        }
        const hiddenColsStr = localStorage.getItem(`${LOCAL_STORAGE_TABLE_KEY}${hidableColsLocalStorageKey}`) || '[]';
        return JSON.parse(hiddenColsStr);
    }, [hidableColsLocalStorageKey]);
    const [hiddenCols, setHiddenCols] = React.useState(hiddenColsFromLocalStorage || []);
    const [tempHiddenCols, setTempHiddenCols] = React.useState(hiddenColsFromLocalStorage || []);
    const [hidableColsPopinOpen, setHidableColsPopinOpen] = React.useState(false);
    const openHidableColsPopin = React.useCallback(() => {
        setTempHiddenCols([...hiddenCols]);
        setHidableColsPopinOpen(true);
    }, [hiddenCols]);
    const closeHidableColsPopin = React.useCallback(() => {
        setTempHiddenCols([...hiddenCols]);
        setHidableColsPopinOpen(false);
    }, [hiddenCols]);
    const makeToggleTempHiddenCol = React.useCallback((key) => () => {
        setTempHiddenCols(array.addOrRemove(tempHiddenCols, key));
    }, [tempHiddenCols]);
    const updateHiddenCols = React.useCallback(() => {
        setHiddenCols([...tempHiddenCols]);
        closeHidableColsPopin();
        if (hidableColsLocalStorageKey) {
            localStorage.setItem(`${LOCAL_STORAGE_TABLE_KEY}${hidableColsLocalStorageKey}`, JSON.stringify(tempHiddenCols));
        }
    }, [hidableColsLocalStorageKey, tempHiddenCols, closeHidableColsPopin]);
    const columnsToShow = React.useMemo(() => columns.filter(column => !hiddenCols.includes(column.key)), [columns, hiddenCols]);
    const hidableColsSettingsElement = React.useMemo(() => {
        if (!withHidableCols || !columns.length) {
            return null;
        }
        return (React__default.default.createElement(HidableColsSettingsPopin, { id: id, columns: columns, hiddenCols: hiddenCols, tempoHiddenCols: tempHiddenCols, hidableColsPopinOpen: hidableColsPopinOpen, onSettingsClick: openHidableColsPopin, onCancelClick: closeHidableColsPopin, makeOnSwitchChange: makeToggleTempHiddenCol, onSaveClick: updateHiddenCols, labelSettingsTitle: labelSettingsTitle, labelSettingsSave: labelSettingsSave, labelSettingsCancel: labelSettingsCancel }));
    }, [
        withHidableCols,
        columns,
        id,
        hiddenCols,
        tempHiddenCols,
        hidableColsPopinOpen,
        openHidableColsPopin,
        closeHidableColsPopin,
        makeToggleTempHiddenCol,
        updateHiddenCols,
        labelSettingsTitle,
        labelSettingsSave,
        labelSettingsCancel,
    ]);
    return { columnsToShow, hidableColsSettingsElement };
}

exports.LOCAL_STORAGE_TABLE_KEY = LOCAL_STORAGE_TABLE_KEY;
exports.useHidableCols = useHidableCols;
//# sourceMappingURL=useHidableCols.js.map
